import { render } from "./contentCategoryOverviewItemListCard.vue?vue&type=template&id=658572a2&scoped=true&ts=true"
import script from "./contentCategoryOverviewItemListCard.vue?vue&type=script&lang=ts"
export * from "./contentCategoryOverviewItemListCard.vue?vue&type=script&lang=ts"

import "./contentCategoryOverviewItemListCard.vue?vue&type=style&index=0&id=658572a2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658572a2"]])

export default __exports__